import { State } from '../reducers/rootReducer'
import AudiExclusiveDataState from '../../entities/AudiExclusiveDataState'

const audiExclusiveDataStateSelector = (state: State): AudiExclusiveDataState => state.audiExclusiveAppDataState

export default audiExclusiveDataStateSelector
